module.exports = __webpack_public_path__ + "img/51.91c93b1d.svg";